module.exports = __webpack_public_path__ + "media/images/features/support_every_file_type_img-200181c05106f0aa568d8ebc704a7313.png";